import React, { useEffect, useState } from "react";
import Header from "../../common/Header.js";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import "../../../assets/user/css/home.css";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { encode } from "base-64";
import { api } from "../../../utlis/admin/api.utlis.js";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";

const Blog = () => {
  const [blogs, setBlog] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  const getBlogList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPI(api);
    // console.log("all blogs list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setBlog(response.data.data.blogs);
      setTotal(response.data.data.total);
    } else setBlog([]);
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogList(api.blogList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <Header></Header>
      {/* <div className="pbmit-slider-item">
        <div className="pbmit-slider-bg"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="pbmit-banner-circle">
                <div className="pbmit-slider-content">
                  <h5 className="pbmit-slider-subtitle">
                    Expert dental services tailored
                  </h5>
                  <h2 className="pbmit-slider-title">
                    Caring sweet Smile for Your Family
                  </h2>
                  <p className="pbmit-slider-desc">
                    Comprehensive Full-service dental treatment and restorations
                    available.
                  </p>
                </div>
                <a className="pbmit-slider-btn">View More About Us </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="care-provider-blog-section blog-banner mt-4 mb-5">
        <div className="container">
          <div className="row g-3">
            {blogs.length !== 0 ? (
              blogs.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="care-blog-card">
                      <div className="blog-media">
                        {ele.blog_image === null ||
                        ele.blog_image === "" ||
                        ele.blog_image === undefined ? (
                          <img
                            src={NoImage}
                            alt=""
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                          />
                        ) : (
                          <img
                            src={ele.blog_image}
                            alt=""
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                          />
                        )}
                      </div>
                      <div className="blog-content">
                        <h2>{ele.title ?? "NA"}</h2>
                        <Link
                          className="btn-gr"
                          to={
                            routes.blogDetail + `${encode(ele.id)}/${ele.slug}`
                          }
                        >
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
